export default "__VITE_ASSET__CXl0H9wu__"